import React from 'react';
import createThemedComponent from '../../../theming/utils/createThemedComponent';
import { ImageStyles } from './Image.styles';
/**
 * Themeable image component that defaults to 500x500px, and gets smaller as the browser width gets smaller.
 *
 * ```js
 * import { Image } from '@minerva-analytics/pantheon';
 * <Image src={minerva_logo.png} />
 * ```
 * **Default Styles**
 *
 * To view the component's styling directly, see [Image.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/elements/Image/Image.styles.js)
 *
 */

export var ImageComponent = function ImageComponent() {
  return /*#__PURE__*/React.createElement(ImageStyles, null);
};
var Image = createThemedComponent('Image', ImageStyles);
export default Image;